<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      <span>Are you sure you want to delete the booking?</span>
    </template>
    <template v-slot:body>
      <div class="delete-booking-description">
        This cannot be undone, please be sure.
      </div>
    </template>
    <template v-slot:actions>
      <div class="delete-booking-actions">
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <ErrorButton @click.native="handleSubmit" :loading="isLoading">
          Delete Booking
        </ErrorButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import {
  BOOKINGS_NAMESPACE,
  DELETE_BOOKING
} from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "DeleteBookingDialog",
  components: { ErrorButton, PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    isOpen: Boolean
  },
  inject: ["currentBookingId"],
  methods: {
    ...mapActions({
      deleteBooking: DELETE_BOOKING
    }),
    async handleSubmit() {
      this.isLoading = true;
      try {
        await this.deleteBooking(this.currentBookingId);
        this.$emit("close");
        await this.$router.push("/bookings");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
